<template>
  <div class="a-loading-primary">
    <img
      alt="loading"
      src="@/assets/loading/loading-animation.gif"
    />
    <p
      v-if="loadingText.length"
      class="margin-top-small"
    >
      <span class="text-color-vidroop-primary">
        {{ loadingText }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'AtomLoadingPrimary',

  props: {
    loadingText: {
      type: String,
      default: ''
    }
  }
}
</script>
